import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit, OnDestroy {
    private sub: Subscription;
    public isSpinnerVisible = false;

    constructor(protected spinner: SpinnerService) {
        this.sub = spinner.isSpinnerVisible$.subscribe((isSpinnerVisible) => {
            this.isSpinnerVisible = isSpinnerVisible;
        });
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/spinner/spinner.component.ts